@if (isServiceDriveRoute) {
@if (screen == 'LOGIN') {
  <div class="row">
    <div class="col-sm-12 col-md-6 offset-md-3 mt-4">
      <div><strong>{{component.primary.title[0].text}}</strong></div>
      <div>{{component.primary.subtitle[0].text}}</div>
      @if (badDealerLogin) {
        <div class="p-0">
          <div class="mt-3">
            <div class="alert alert-warning verify-alert w-100 pb-0 text-center" role="alert">{{
            'SERVICE_DRIVE.CANT_LOGIN' | translate }}</div>
          </div>
        </div>
      }
      <form role="form" class="dealership_login" [formGroup]="loginForm">
        <div class="md-form mt-5">
          @if (thisBrand == 'Lambo' || thisBrand == 'Porsche') {
            <label id="dealerlabel" for="dealershipId">{{
            'SERVICE_DRIVE.DEALER_CODE' | translate }}</label>
          }
          @if (thisBrand != 'Lambo' && thisBrand != 'Porsche') {
            <label id="dealerlabel" for="dealershipId">{{
            'SERVICE_DRIVE.DEALERSHIP_ID' | translate }}</label>
          }
          <input aria-labelledby="dealerlabel" mdbInput mdbValidate type="text" id="dealershipId"
            formControlName="dealershipId" class="form-control" maxlength="17" (blur)="previewDealer()" />
          @if (loginForm.controls.dealershipId.invalid && (loginForm.controls.dealershipId.dirty || loginForm.controls.dealershipId.touched)) {
            <mdb-error role="alert"
              >
              {{ 'SERVICE_DRIVE.DEALER_CODE_REQ' | translate }}
            </mdb-error>
          }
        </div>
        <!-- Dealer Name Display when in Preview Mode -->
        @if (dealerData?.data?.isPreview) {
          <div class="dealer-preview-info p-2">
            <small class="text-muted">
              {{ dealerData.data.Dealer_Name__c }}
            </small>
          </div>
        }
        @if (thisBrand == 'Lambo' || thisBrand == 'Porsche' ||thisBrand == 'Schomp' || thisBrand == 'BMW' || thisBrand == 'MINI') {
          <div class="md-form mt-5"
            >
            @if (thisBrand != 'Lambo' && thisBrand != 'Porsche') {
              <label id="employeelabel" for="employeeId">{{
              'SERVICE_DRIVE.EMPLOYEE_ID' | translate }}</label>
            }
            @if (thisBrand == 'Lambo' || thisBrand == 'Porsche') {
              <label id="employeelabel" for="employeeId">{{
              'SERVICE_DRIVE.EMPLOYEE_EMAIL' | translate }}</label>
            }
            @if (thisBrand != 'Lambo' && thisBrand != 'BMW' && thisBrand != 'Porsche' && thisBrand != 'MINI') {
              <input
                aria-labelledby="employeelabel" mdbInput mdbValidate type="text" id="employeeId"
                formControlName="employeeId" class="form-control" minlength="5" maxlength="5" />
            }
            @if (thisBrand == 'BMW' || thisBrand == 'MINI') {
              <input aria-labelledby="employeelabel" mdbInput
                mdbValidate type="text" id="employeeId" formControlName="employeeId" class="form-control"
                minlength="9" maxlength="9" />
            }
            @if (thisBrand == 'Lambo' || thisBrand == 'Porsche') {
              <input aria-labelledby="employeelabel" mdbInput
                mdbValidate type="email" id="employeeId" formControlName="employeeId" class="form-control"
                maxlength="40" />
            }
            @if (thisBrand != 'Lambo' && thisBrand != 'Porsche' && loginForm.controls.employeeId.invalid && (loginForm.controls.employeeId.dirty || loginForm.controls.employeeId.touched)) {
              <mdb-error role="alert"
                >
                {{ 'SERVICE_DRIVE.EMPLOYEE_ID_REQ' | translate }}
              </mdb-error>
            }
            @if ((thisBrand == 'Lambo' || thisBrand == 'Porsche') && loginForm.controls.employeeId.invalid && (loginForm.controls.employeeId.dirty || loginForm.controls.employeeId.touched)) {
              <mdb-error role="alert"
                >
                {{ 'SERVICE_DRIVE.EMPLOYEE_EMAIL_REQ' | translate }}
              </mdb-error>
            }
          </div>
        }
        @if (thisBrand == 'Hyundai' || thisBrand == 'HPP' || thisBrand == 'Genesis') {
          <div class="md-form mt-5">
            @if (thisBrand == 'Hyundai' || thisBrand == 'HPP') {
              <label id="employeelabel" for="employeeId">HMA {{
              'SERVICE_DRIVE.EMPLOYEE_ID' | translate }}</label>
            }
            @if (thisBrand != 'Hyundai' && thisBrand != 'HPP') {
              <label id="employeelabel" for="employeeId">{{
              'SERVICE_DRIVE.EMPLOYEE_ID' | translate }}</label>
            }
            <input aria-labelledby="employeelabel" mdbInput mdbValidate type="text" id="employeeId"
              formControlName="employeeId" class="form-control" minlength="12" maxlength="12" />
            @if (loginForm.controls.employeeId.invalid && (loginForm.controls.employeeId.dirty || loginForm.controls.employeeId.touched)) {
              <mdb-error role="alert"
                >
                *@if (thisBrand == 'Hyundai' || thisBrand == 'HPP') {
                <span>HMA </span>
                }{{
                'SERVICE_DRIVE.EMPLOYEE_ID_REQ' | translate }}
              </mdb-error>
            }
          </div>
        }
        @if (thisBrand == 'Lambo' || thisBrand == 'Porsche' || thisBrand == 'Hyundai' || thisBrand == 'HPP' || thisBrand == 'Genesis' || thisBrand == 'BMW' || thisBrand == 'MINI') {
          <div class="md-form mt-5"
            >
            <label id="employeeFirstNameLabel" for="employeeFirstName">{{ 'SERVICE_DRIVE.EMPLOYEE_FIRST_NAME' |
            translate }}</label>
            <input aria-labelledby="employeeFirstNameLabel" mdbInput mdbValidate type="text" id="employeeFirstName"
              formControlName="employeeFirstName" class="form-control" maxlength="17" />
            @if (loginForm.controls.employeeFirstName.invalid && (loginForm.controls.employeeFirstName.dirty || loginForm.controls.employeeFirstName.touched)) {
              <mdb-error role="alert"
                >
                {{ 'SERVICE_DRIVE.EMPLOYEE_FIRST_NAME_REQ' | translate }}
              </mdb-error>
            }
          </div>
        }
        @if (thisBrand == 'Lambo' || thisBrand == 'Porsche' || thisBrand == 'Hyundai' || thisBrand == 'HPP' || thisBrand == 'Genesis' || thisBrand == 'BMW' || thisBrand == 'MINI') {
          <div class="md-form mt-5"
            >
            <label id="employeeLastNameLabel" for="employeeLastName">{{ 'SERVICE_DRIVE.EMPLOYEE_LAST_NAME' |
            translate }}</label>
            <input aria-labelledby="employeeLastNameLabel" mdbInput mdbValidate type="text" id="employeeLastName"
              formControlName="employeeLastName" class="form-control" maxlength="17" />
            @if (loginForm.controls.employeeLastName.invalid && (loginForm.controls.employeeLastName.dirty || loginForm.controls.employeeLastName.touched)) {
              <mdb-error role="alert"
                >
                {{ 'SERVICE_DRIVE.EMPLOYEE_LAST_NAME_REQ' | translate }}
              </mdb-error>
            }
          </div>
        }
        <div class="mt-5">
          <button mdbBtn id="scanVinButton" class="modal-component-see-pricing-btn btn primary-btn flat waves-light" mdbWavesEffect
            type="button" (click)="validateDealer('CAPTURE')">
            {{ 'SERVICE_DRIVE.SCAN_VIN' | translate }}
          </button>
        </div>
        <div class="text-center w-100 mt-2 mb-4"><a id="manualVinInputLink" (click)="validateDealer('CUSTOMER'); readonly = false;"
        class="blue-link uppercase">{{ 'SERVICE_DRIVE.MANUAL_VIN_INPUT' | translate }}</a>
      </div>
    </form>
  </div>
</div>
}

@if (screen == 'CAPTURE') {
  <div class="row">
    <div class="col-12">
      <div class="text-center w-100 mt-2">
        @if (showCamera == false) {
          <div class="preloader-wrapper active indicator mt-5 mb-5">
            <div class="spinner-layer spinner-client-color">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div>
              <div class="gap-patch">
                <div class="circle"></div>
              </div>
              <div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
        }
        <div id="scandit-barcode-picker" [class]="{'show': showCamera == true}"></div>
        <div [hidden]="!barcodeValues || barcodeValues.length == 0" class="mt-2">
          <strong>{{ 'SERVICE_DRIVE.CLICK_TO_USE' | translate }}</strong><br>
          @for (barcode of barcodeValues; track barcode; let i = $index) {
            <div class="mt-2 mb-2"><button id="selectVinButton{{i}}" class="btn primary-btn"
            (click)="useVIN(barcode)">{{ barcode }}</button></div>
          }
        </div>
        <div class="text-center w-100 mt-2"><a id="manualVinInputLinkFromCapture" (click)="validateDealer('CUSTOMER'); readonly = false;"
        class="blue-link uppercase">{{ 'SERVICE_DRIVE.MANUAL_VIN_INPUT' | translate }}</a></div>
        <div class="mt-2 mb-4"><a id="backToLoginLink" (click)="loadView('LOGIN')" class="blue-link uppercase">{{
        'SERVICE_DRIVE.BACK_TO_LOGIN' | translate }}</a></div>
      </div>
    </div>
  </div>
}

@if (screen == 'CUSTOMER') {
  <div class="row">
    <div class="col-sm-12 col-md-4 offset-md-4 mt-4 mb-4">
      <div><strong>{{component.primary.vin_title[0].text}}</strong></div>
      <div>{{component.primary.vin_subtitle[0].text}}</div>
    </div>
    @if (showError) {
      <div class="p-0 col-12">
        <div class="mb-3">
          @if (thisBrand !== 'Lambo' && thisBrand !== 'Porsche') {
            <div
              class="alert alert-warning verify-alert w-100 pb-0 text-center" role="alert">{{
            'SERVICE_DRIVE.NOT_ELIGIBLE' | translate }}</div>
          }
          @if (thisBrand === 'Lambo' && errorMessage === 1) {
            <div
              class="alert alert-warning verify-alert w-100 pb-0 text-center" role="alert">{{
            'SERVICE_DRIVE.NOT_ELIGIBLE_LAMBO' | translate }}.</div>
          }
          @if (thisBrand === 'Lambo' && errorMessage === 2) {
            <div
              class="alert alert-warning verify-alert w-100 pb-0 text-center" role="alert">{{
            'ERRORS.NO_ELIGIBLE_PRODUCTS' | translate }} {{branding.cs_phone_number }}</div>
          }
          @if (thisBrand === 'Porsche') {
            <div class="alert alert-warning verify-alert w-100 pb-0 text-center"
              style="max-width: 400px; margin: 0 auto;" role="alert">{{ 'SERVICE_DRIVE.PRODUCT_EXIST' | translate: {
            phone: branding.cs_phone_number } }}</div>
          }
        </div>
      </div>
    }
    <div class="manual_container col-12">
      <form role="form" class="vehicle_login row" [formGroup]="customerForm">
        <div class="vehicle pr-3 pl-3 mt-3">
          <div class="vehicle_login row">
            <div class="col-12 pb-5 pr-1 pl-1">
              <div class="md-form">
                <label id="vinlabel" for="vin">{{ 'CART_CHECKOUT.VIN' | translate }}</label>
                <input aria-labelledby="vinlabel" mdbInput mdbValidate type="text" id="vin"
                  oninput="this.value = this.value.toUpperCase()" [readonly]="readonly"
                  formControlName="vin" class="form-control" minlength="17" maxlength="17"
                  [class]="{'grey-input': readonly}" autocomplete="off"
                  (change)="lookupVin(customerForm.controls.vin.value)" />
                @if (customerForm.controls.vin.invalid && (customerForm.controls.vin.dirty || customerForm.controls.vin.touched)) {
                  <mdb-error role="alert"
                    >
                    @if (!customerForm.controls.vin.errors?.pattern) {
                      <span>*{{ 'ASP_LANDING.VIN_REQUIRED'
                      | translate }}</span>
                    }
                    @if (customerForm.controls.vin.errors?.pattern && customerForm.controls.vin.errors?.pattern.requiredPattern.indexOf('[a-zA-Z0-9]{0,17}') > -1) {
                      <span
                        >*{{
                      'ASP_LANDING.VALID_VIN' | translate }}</span>
                    }
                    @if (customerForm.controls.vin.errors?.pattern && customerForm.controls.vin.errors?.pattern.requiredPattern.indexOf('[a-zA-Z0-9]{0,12}[0-9]{5}$') > -1) {
                      <span
                        >
                        <span><strong class="uppercase">*{{ 'ASP_LANDING.INVALID_VIN' | translate }}
                        </strong></span>
                        <span>{{ 'ASP_LANDING.INVALID_VIN_MSG_3' | translate }}</span></span>
                      }
                      @if (customerForm.controls.vin.errors?.pattern && customerForm.controls.vin.errors?.pattern.requiredPattern.indexOf('[^IOQioq ]{0,17}') > -1) {
                        <span
                          >
                          <span><strong class="uppercase">*{{ 'ASP_LANDING.INVALID_VIN' | translate }}
                          </strong></span>
                          <span>{{ 'ASP_LANDING.INVALID_VIN_MSG' | translate }}</span>
                        </span>
                      }
                    </mdb-error>
                  }
                  @if (customerForm.controls.vin.valid && invalidVin) {
                    <mdb-error role="alert">
                      {{ 'ASP_LANDING.VALID_VIN' | translate }}
                    </mdb-error>
                  }
                </div>
              </div>
              <div class="col-4 pr-1 pl-1 pb-5">
                <div class="md-form">
                  <label id="yearlabel" for="year">{{ 'CART_CHECKOUT.YEAR' | translate }}</label>
                  <input aria-labelledby="yearlabel" mdbInput mdbValidate type="number" id="year" readonly
                    formControlName="year" class="form-control grey-input" max="9999" />
                  @if (customerForm.controls.year.invalid && (customerForm.controls.year.dirty || customerForm.controls.year.touched)) {
                    <mdb-error role="alert"
                      >
                      *Year required.
                    </mdb-error>
                  }
                </div>
              </div>
              <div class="col-4 pr-1 pl-1 pb-5">
                <div class="md-form">
                  <label id="makeLabel" for="make">{{ 'CART_CHECKOUT.MAKE' | translate }}</label>
                  <input aria-labelledby="makeLabel" mdbInput mdbValidate type="text" id="make" readonly
                    formControlName="make" class="form-control grey-input" maxlength="20" />
                  @if (customerForm.controls.make.invalid && (customerForm.controls.make.dirty || customerForm.controls.make.touched)) {
                    <mdb-error role="alert"
                      >
                      *Make required.
                    </mdb-error>
                  }
                </div>
              </div>
              <div class="col-4 pr-1 pl-1 pb-5">
                <div class="md-form">
                  <label id="modelLabel" for="model">{{ 'CART_CHECKOUT.MODEL' | translate }}</label>
                  <input aria-labelledby="modelLabel" mdbInput mdbValidate type="text" id="model" readonly
                    formControlName="model" class="form-control grey-input" maxlength="30" />
                  @if (customerForm.controls.model.invalid && (customerForm.controls.model.dirty || customerForm.controls.model.touched)) {
                    <mdb-error role="alert"
                      >
                      *Model required.
                    </mdb-error>
                  }
                </div>
              </div>
              <div class="col-12 pr-1 pl-1 pb-1">
                <div class="md-form">
                  <label id="odometerlabel" for="odometer">{{ 'CART_CHECKOUT.ODOMETER' | translate }}</label>
                  <input aria-labelledby="odometerlabel" mdbInput mdbValidate type="text" id="odometer"
                    formControlName="odometer" class="form-control" (keypress)="onlyNumberKey($event)"
                    (focus)="removeCommas()" (change)="removeCommas()" (blur)="addCommas()" max="100000" />
                  @if (customerForm.controls.odometer.invalid && (customerForm.controls.odometer.dirty || customerForm.controls.odometer.touched)) {
                    <mdb-error role="alert"
                      >
                      {{ 'SERVICE_DRIVE.ODOMETER_REQ' | translate }}
                    </mdb-error>
                  }
                </div>
                @if (thisBrand == 'Porsche') {
                  <span class="valid-photo">{{ 'SERVICE_DRIVE.VALID_PORSCHE' |
                  translate }}</span>
                }
                @if (thisBrand == 'Hyundai' || thisBrand == 'HPP' || thisBrand == 'Genesis') {
                  <span class="valid-photo"
                    >{{
                  'SERVICE_DRIVE.VALID_ODOMETER' | translate }}</span>
                }
              </div>
              @if (serviceDriveUseWarranty) {
                <div class="col-12 pr-1 pl-1 pb-5 mt-5"
                  >
                  <div class="md-form text-left no-shadow">
                    <label id="warrantylabel" for="hasWarranty">{{ 'SERVICE_DRIVE.NEW_CAR_WARRANTY' | translate
                    }}</label>
                    <button id="warrantyYesButton" (click)="setWarranty(true)"
                      [class]="{active: customerForm.controls.hasWarranty.value == true}"
                    class="btn uppercase warranty_btn">{{ 'RATES_PAGE.YES' | translate }}</button>&nbsp;
                    <button id="warrantyNoButton" (click)="setWarranty(false)"
                      [class]="{active: customerForm.controls.hasWarranty.value == false}"
                    class="btn uppercase warranty_btn">{{ 'RATES_PAGE.NO' | translate }}</button>
                    <div class="w-100 error-message mt-2">{{ 'SERVICE_DRIVE.INSPECTION_DOCUMENT' | translate }}
                    </div>
                  </div>
                </div>
              }
              @if (thisBrand == 'Lambo') {
                <div class="col-12 pr-1 pl-1 text-left">
                  <span class="inspection-statement">{{ 'SERVICE_DRIVE.PASS_CHECKLIST' | translate }}</span>
                </div>
              }
              @if (serviceDriveUseISD && showISD) {
                <div class="col-4 pr-1 pl-1 pb-3 pt-5"
                  >
                  <div class="md-form">
                    <label id="ISDMonthLabel" for="ISDMonth">{{ 'SERVICE_DRIVE.ISD_MONTH' | translate }}</label>
                    <select role="listbox" class="form-control" id="ISDMonth" placeholder="Month"
                      formControlName="isdMonth" [ngClass]="{'disabled': disableISD}">
                      @for (month of months; track month) {
                        <option value="{{ month.value }}">
                          {{ month.label }}
                        </option>
                      }
                    </select>
                    @if (customerForm.controls.isdMonth.invalid && (customerForm.controls.isdMonth.dirty || customerForm.controls.isdMonth.touched)) {
                      <mdb-error role="alert"
                        >
                        *Month required.
                      </mdb-error>
                    }
                  </div>
                </div>
              }
              @if (serviceDriveUseISD && showISD) {
                <div class="col-4 pr-1 pl-1 pb-3 pt-5"
                  >
                  <div class="md-form">
                    <label id="ISDDaylabel" for="ISDDay">{{ 'SERVICE_DRIVE.ISD_DAY' | translate }}</label>
                    <select role="listbox" class="form-control" id="ISDDay" placeholder="Day"
                      formControlName="isdDay" [ngClass]="{'disabled': disableISD}">
                      @for (day of days; track day) {
                        <option value="{{ day.value }}">
                          {{ day.label }}
                        </option>
                      }
                    </select>
                    @if (customerForm.controls.isdDay.invalid && (customerForm.controls.isdDay.dirty || customerForm.controls.isdDay.touched)) {
                      <mdb-error role="alert"
                        >
                        *Day required.
                      </mdb-error>
                    }
                  </div>
                </div>
              }
              @if (serviceDriveUseISD && showISD) {
                <div class="col-4 pr-1 pl-1 pb-3 pt-5"
                  >
                  <div class="md-form">
                    <label id="ISDYearLabel" for="ISDYear">{{ 'SERVICE_DRIVE.ISD_YEAR' | translate }}</label>
                    <select role="listbox" class="form-control" id="ISDYear" placeholder="Year"
                      formControlName="isdYear" [ngClass]="{'disabled': disableISD}">
                      @for (year of years; track year) {
                        <option value="{{ year.value }}">
                          {{ year.label }}
                        </option>
                      }
                    </select>
                    @if (customerForm.controls.isdYear.invalid && (customerForm.controls.isdYear.dirty || customerForm.controls.isdYear.touched)) {
                      <mdb-error role="alert"
                        >
                        *Year required.
                      </mdb-error>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </form>
      </div>
      <div class="col-12">
        <div class="mt-4">
          <button mdbBtn id="viewRatesButton" class="modal-component-see-pricing-btn btn primary-btn flat waves-light" (click)="getRates()"
            mdbWavesEffect type="submit">
            @if (thisBrand === 'Porsche') {
              <span>{{ 'SERVICE_DRIVE.SHOP_PRODUCTS' | translate }}</span>
            }
            @if (thisBrand !== 'Porsche') {
              <span>{{ 'SERVICE_DRIVE.VIEW_RATES' | translate }}</span>
            }
          </button>
        </div>
        <div class="text-center w-100 mt-2 mb-4">
          <a id="changeVehicleLink" (click)="loadView('CAPTURE')" class="blue-link uppercase">{{ 'SERVICE_DRIVE.CHANGE_VEHICLE' | translate
          }}</a>
        </div>
      </div>
    </div>
  }
}